import { FadeIn } from "@/components/FadeIn";
import { Check, Award } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const About = ({ content }) => {
  const { t, tc } = useLang();
  return (
    <section id="ueber-uns" data-testid="about-section" className="py-24 md:py-32 bg-slate-50 border-y border-slate-200">
      <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <FadeIn>
          <div className="relative">
            <img src={content.about_image} alt="Über uns" className="rounded-3xl w-full h-[420px] sm:h-[500px] object-cover shadow-xl shadow-slate-300/40" />
            <div className="absolute -bottom-6 -right-2 sm:right-6 bg-blue-600 rounded-3xl px-7 py-5 shadow-2xl shadow-blue-600/30">
              <div className="flex items-center gap-3">
                <Award className="w-9 h-9 text-white" />
                <div>
                  <div className="text-3xl font-extrabold text-white leading-none">30+</div>
                  <div className="text-xs text-blue-100 uppercase tracking-wider">{t("about.years")}</div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.15}>
          <span className="overline">{t("about.overline")}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-5">{tc(content.about_title)}</h2>
          <p className="text-slate-600 md:text-lg leading-relaxed mb-8">{tc(content.about_text)}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {(content.about_highlights || []).map((h, i) => (
              <div key={i} data-testid={`highlight-${i}`} className="flex items-center gap-3">
                <span className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-blue-600" />
                </span>
                <span className="text-slate-700 text-sm">{tc(h)}</span>
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
